import { Box, CircularProgress } from '@mui/material';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useTranslation } from '../../hooks/useTranslation';

const PrivateRoute = ({ children }: { children: JSX.Element }) => {
    const { currentUser } = useAuth();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [isVerifyingAuth, setIsVerifyingAuth] = useState(true);

    useEffect(() => {
        // Add a small delay to avoid flashing of content
        const timeout = setTimeout(() => {
            setIsVerifyingAuth(false);
        }, 300); // Reduced delay for better user experience

        return () => clearTimeout(timeout);
    }, []);

    // Show loading state while auth is being checked
    if (isVerifyingAuth) {
        return (
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '100%',
                    height: '100vh',
                }}
                role="status"
                aria-label={t('auth.privateRoute.verifyingAuth')}
            >
                <CircularProgress color="primary" size={40} thickness={4} />
            </Box>
        );
    }

    // Auth check failed - redirect to login
    if (!currentUser) {
        sessionStorage.setItem('redirectAfterLogin', location.pathname);
        // Navigate to /login which will redirect to main CoinTracking
        navigate('/login');
        return null;
    }


    // Email verification is no longer required for any routes
    // Users can access the entire app without email verification

    // All checks passed, render the protected content
    return children;
};

export default PrivateRoute;
